import { createContext } from 'react'

import { ReportEditorStore } from '../lib/Store'

export const reportStoreContext = createContext<ReportEditorStore | undefined>(undefined)
